var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm._diffArr)?_c('div',{staticClass:"ws-info-string-compare"},_vm._l((_vm._diffArr),function(diffItem,diffKey){return _c('span',{key:diffKey,class:_vm.$_getDiffClass(diffItem)},[_vm._v(_vm._s(diffItem.value))])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }